<template>
    <section class="contact-referral-partner">
        <div class="referral-partner-header create-header">
            <h3>Referral partner</h3>

            <ds-filled-button data-qa="create-referral" @click="createReferral">
                Create referral
            </ds-filled-button>
        </div>

        <h4 class="sub-header">
            Current referral partner
        </h4>

        <Contact-referral-partner-table
            v-if="isContactHasCurrentReferralPartner"
            class="current-referral-table"
            :referal-partners="currentReferralPartner"
            data-qa="current-referral-table"
            @editReferral="editReferral"
        />

        <div v-else class="no-data" data-qa="no-current-referral-partner">
            This contact does not have current referral partner
        </div>

        <h4 class="sub-header">
            Referral partner referrals
        </h4>

        <Contact-referral-partner-table
            v-if="isContactHasReferralPartners"
            :referal-partners="referralPartnersList"
            data-qa="referral-partners-referrals-list"
            @editReferral="editReferral"
        />

        <div v-else class="no-data" data-qa="no-referral-partner-referrals">
            This contact does not have any referral partner referrals
        </div>

        <h4 class="sub-header">
            Referral partner click history
        </h4>

        <div v-if="isContactHasReferralPartnerClickHistory" class="table-wrapper">
            <table>
                <tr>
                    <th style="width: 25%">
                        <div class="cell">
                            Click date
                        </div>
                    </th>
                    <th style="width: 20%">
                        <div class="cell">
                            IP address
                        </div>
                    </th>
                    <th style="width: 25%">
                        <div class="cell">
                            Click url
                        </div>
                    </th>
                    <th v-if="permission" style="width: 20%">
                        <div class="cell">
                            Affiliate
                        </div>
                    </th>
                    <th style="width: 20%">
                        <div class="cell">
                            Website
                        </div>
                    </th>
                    <th style="width: 20%">
                        <div class="cell">
                            Ad
                        </div>
                    </th>
                </tr>
                <div
                    v-for="(clickHistory, i) in referralPartnerClickHistory"
                    :key="i"
                    class="click-history"
                    data-qa="referral-partner-click-history"
                >
                    <tr
                        v-if="clickHistory.jumpLogId"
                        class="referral-details"
                    >
                        <td>
                            {{ clickHistory.clickDate }}
                        </td>
                        <td>
                            {{ clickHistory.remoteIP }}
                        </td>
                        <td class="fix-width">
                            {{ clickHistory.jumpLogUri }}
                        </td>
                        <td v-if="permission" class="fix-width">
                            {{ clickHistory.affName ? clickHistory.affName : 'N/A' }}
                        </td>
                        <td class="fix-width">
                            {{ clickHistory.jumperName }}
                        </td>
                        <td class="fix-width">
                            {{ clickHistory.affBlastName }}
                        </td>
                    </tr>
                    <tr
                        v-if="clickHistory.customFormWebResultId"
                        class="referral-details"
                    >
                        <td>
                            {{ clickHistory.customFormWebResultFormDate ? clickHistory.customFormWebResultFormDate : 'No Date Available' }}
                        </td>
                        <td>
                            {{ clickHistory.customFormWebResultIPAddress }}
                        </td>
                        <td class="fix-width">
                            {{ clickHistory.customFormWebName }}
                        </td>
                        <td v-if="permission" class="fix-width">
                            {{ clickHistory.affName ? clickHistory.affName : 'N/A' }}
                        </td>
                        <td>
                            WEB FORM
                        </td>
                        <td>
                            N/A
                        </td>
                    </tr>
                    <tr
                        v-if="clickHistory.customFormSaleResultId"
                        class="referral-details"
                    >
                        <td>
                            {{ clickHistory.customFormSaleResultFormDate ? clickHistory.customFormSaleResultFormDate : 'No Date Available' }}
                        </td>
                        <td>
                            SALE FORM
                        </td>
                        <td class="fix-width">
                            {{ clickHistory.customFormSaleName ? clickHistory.customFormSaleName : 'N/A' }}
                        </td>
                        <td v-if="permission" class="fix-width">
                            {{ clickHistory.affName ? clickHistory.affName : 'N/A' }}
                        </td>
                        <td class="fix-width">
                            {{ clickHistory.customFormSaleIPAddress }}
                        </td>
                        <td>
                            N/A
                        </td>
                    </tr>
                </div>
            </table>
        </div>

        <div v-else class="no-data" data-qa="no-referral-partner-click-history">
            This contact does not have any click history
        </div>

        <Contact-create-referral-partner-modal
            ref="createReferralModal"
            :contact="contact"
            data-qa="referral-modal"
            @saveReferral="saveReferral"
            @updateReferral="updateReferral"
            @removeReferral="removeReferral"
        />
    </section>
</template>

<script>
import ContactReferralPartnerTable from './ContactReferralPartnerTable.vue';
import ContactCreateReferralPartnerModal from './ContactCreateReferralPartnerModal.vue';
import axios from 'axios';

export default {
    components: {
        ContactReferralPartnerTable,
        ContactCreateReferralPartnerModal,
    },

    props: {
        contact: Object,
    },

    data() {
        return {
            referralPartnersList: [],
            currentReferralPartner: [],
            referralPartnerClickHistory: [],
            url: '/app/affiliate',
            permission: Boolean,
        };
    },

    created() {
        this.loadReferralPartnersList();
        this.loadReferralPartnerClickHistory();
        this.loadPermission();
    },

    computed: {
        isContactHasReferralPartners() {
            return Boolean(this.referralPartnersList.length);
        },

        isContactHasCurrentReferralPartner() {
            return Boolean(this.currentReferralPartner.length);
        },

        isContactHasReferralPartnerClickHistory() {
            return Boolean(this.referralPartnerClickHistory.length);
        },
    },

    methods: {
        async loadReferralPartnersList() {
            this.currentReferralPartner = [];

            try {
                const response = await axios.get(`${this.url}/getAllReferrals/${this.contact.id}`);

                this.currentReferralPartner = response.data.splice(0, 1);
                this.referralPartnersList = response.data;
            } catch (error) {
                this.$error({ message: 'Unable to get contact referral partners for this contact' });
            }
        },

        async loadPermission() {
            try {
                const response = await axios.get(`${this.url}/getAffiliatePermission`);

                this.permission = response.data;
            } catch (error) {
                this.$error({ message: 'Unable to get affilialte permission for this contact' });
            }
        },

        async loadReferralPartnerClickHistory() {
            try {
                const response = await axios.get(`${this.url}/clickHistoryReferrals/${this.contact.id}`);

                this.referralPartnerClickHistory = response.data;
            } catch (error) {
                this.$error({ message: 'Unable to get contact referral partner click history for this contact' });
            }
        },

        createReferral() {
            this.$refs.createReferralModal.showModal(null);
        },

        editReferral(item) {
            this.$refs.createReferralModal.showModal(item);
        },

        saveReferral(data) {
            try {
                axios.post(`${this.url}/saveReferral`, data);

                this.$refs.createReferralModal.modalClose();
                this.$toast({ message: 'Referral Partner added successfully' });
                this.loadReferralPartnersList();
            } catch (error) {
                this.$error({ message: 'Unable to create contact referral partners for this contact' });
            }
        },

        updateReferral(data) {
            try {
                axios.put(`${this.url}/updateReferral`, data);

                this.$refs.createReferralModal.modalClose();
                this.$toast({ message: 'Referral Partner updated successfully' });
                this.loadReferralPartnersList();
            } catch (error) {
                this.$error({ message: 'Unable to update contact referral partners for this contact' });
            }
        },

        removeReferral(id) {
            try {
                axios.delete(`${this.url}/deleteReferral/${id}`);

                this.$refs.createReferralModal.modalClose();
                this.$toast({ message: 'Referral Partner deleted successfully' });
                this.loadReferralPartnersList();
            } catch (error) {
                this.$error({ message: 'Unable to delete contact referral partners for this contact' });
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.contact-referral-partner {
    padding-top: $spacing-100;

    .referral-partner-header {
        display: flex;
        justify-content: space-between;
        padding: $spacing-200 0 0;
    }

    .sub-header {
        padding: $spacing-400 0 $spacing-200;
        line-height: 1.2;
    }

    .no-data {
        font-size: 1.2rem;
        padding: $spacing-600;
        text-align: center;
        color: $color-gray-darker;
    }

    .create-header {
        display: flex;
        justify-content: space-between;
        padding: $spacing-200 0;
        align-items: center;
        border-bottom: solid px-to-rem(1px) $color-gray-200;
    }

    .click-history {
       display: table-row-group;
    }

    .referral-details:hover {
        background-color: $color-gray-20;
    }

    .fix-width {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        width: 100%;
    }
}
</style>
